import React, { Component } from "react";
import NavBottom from "../../base/features/blocks/NavBottom";
import { BiSearch } from "react-icons/bi";
import { Link } from "react-router-dom";
import DynamicView from "../dynamicView/DynamicView";

class Home extends Component {
  render() {
    return (
      <div>
        <div className="container-fluid px-0" dir="rtl">
          <header
            className="row py-2-3 px-3 mx-0 bg-white shadow-sm position-fixed"
            style={{ top: "0", right: "0", left: "0", zIndex: "9" }}
          >
            <div className="col">
              <span className="fw-bold fs-3">گیتی مارکت</span>
            </div>

            <div className="col-auto align-self-center">
              <Link to="/search" className="p-1">
                <BiSearch className="fs-1" />
              </Link>
            </div>
          </header>
          <body style={{ marginTop: "80px", marginBottom: "90px" }}>
            <DynamicView viewPage={"home"} />
          </body>
        </div>
        <NavBottom />
      </div>
    );
  }
}

export default Home;
